<template>
  <div>
    <h5>{{title}}</h5>

    <p v-html="getDecodedHtml(description)"></p>

    <b-form @submit.prevent="submit()" class="form-horizontal">

      <slot></slot>

      <slot name="buttons">
        <b-btn variant="primary" type="submit" class="ml-2 pull-right">{{ submitString ? submitString : isLast ? 'Submit' : 'Save and Next'}}</b-btn>
        <b-btn variant="secondary" @click="previous()" class="ml-2 pull-right" v-if="!isFirst">Back</b-btn>
      </slot>
    </b-form>

  </div>
</template>

<script>
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {};
  },

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    submitString: {
      type: String,
      required: false,
      default: null
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    getDecodedHtml(encodedString) {
      if (encodedString) {
        return htmlDecode(encodedString);
      }
      return "";
    },

    submit() {
      this.$emit("submit");
    },

    previous() {
      this.$emit("previous");
    }
  }
};
</script>

<style scoped>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
